<template>
  <section
    id="about"
    class="content my-[100px] flex items-start gap-[300px] relative max-md:flex-col max-md:gap-[100px]"
  >
    <img
      src="../assets/images/bg-tablet-pattern.svg"
      alt="bg"
      class="bg-section absolute top-[350px] left-[-500px] z-[-1]"
    />

    <article class="info max-md:text-center">
      <h2 class="text-[2rem] font-bold mb-[20px] max-md:text-[2.5rem]">
        What’s different about Manage?
      </h2>
      <p>
        Manage provides all the functionality your team needs, without the
        complexity. Our software is tailor-made for modern digital product
        teams.
      </p>
    </article>
    <article class="features-list">
      <ul class="flex flex-col gap-[50px]">
        <li v-for="(features, i) in featuresList" :key="i">
          <h4 class="mb-[20px] font-[600]">
            <span>0{{ features.id }}</span
            >{{ features.title }}
          </h4>
          <p>{{ features.par }}</p>
        </li>
      </ul>
    </article>
  </section>
</template>

<script>
export default {
  data() {
    return {
      featuresList: [
        {
          id: 1,
          title: "Track company-wide progress",
          par: `See how your day-to-day tasks fit into the wider vision. Go from 
                tracking progress at the milestone level all the way done to the 
                smallest of details. Never lose sight of the bigger picture again.`,
        },
        {
          id: 2,
          title: "Advanced built-in reports",
          par: `Set internal delivery estimates and track progress toward company 
                goals. Our customisable dashboard helps you build out the reports 
                you need to keep key stakeholders informed.`,
        },
        {
          id: 3,
          title: "Everything you need in one place",
          par: `Stop jumping from one service to another to communicate, store files, 
                track tasks and share documents. Manage offers an all-in-one team 
                productivity solution.`,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.features-list {
  h4 {
    position: relative;

    @media (max-width: 768px) {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    span {
      display: block;
      width: 50px;
      height: 30px;
      background-color: $orange;
      color: white;
      text-align: center;
      font-size: 14px;
      align-content: center;
      border-radius: 20px;

      @media (min-width: 768px) {
        position: absolute;
        top: 50%;
        left: -80px;
        transform: translateY(-50%);
      }
    }

    @media (max-width: 768px) {
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 200%;
        height: 100%;
        background: $orange-hover;
        border-radius: 20px;
        z-index: -1;
      }
    }
  }
}
</style>
